module.exports = __webpack_public_path__ + "static/media/login_img.15f6ad90.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/login_img.png
// module id = 297
// module chunks = 10